// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__UmYgg","info":"styles_info__YgiUB","sourceLink":"styles_sourceLink__YC1KD"};